'use strict';

import { createHtmlElement, detectMobile } from '../../functions';
import {isMobile, settingsData} from '../../settings';
import {rightNavMenuZIndexChange} from "../navigation/right-nav-bar";
import {changeLangToCurrent, getCurrentLang, getCurrentLangDirection} from '../language/langSwitcher';
import { getOrbitControlsCurrentPolarAngle } from '../controls/orbitControls';
import {ViewMode} from "../../common";

export function headerInit (crmSettings) {
    //if (!crmSettings.general.fullWebsite){
    if (!isMobile){
        return;
    }

    const header = createHtmlElement(document.body,'','header',[]);
    const burgerMenu = createHtmlElement(header,'','label',['header__burger-menu','icon-burger']);
    burgerMenu.setAttribute('for','burgerMenu');
    const burgerMenuInput = createHtmlElement(header,'','input',['header__burger-menu__input']);
    burgerMenuInput.type = 'checkbox';
    burgerMenuInput.setAttribute('id','burgerMenu');
    const leftSide = createHtmlElement(header,'','div',['header__left-side__container']);
    const substrateMenu = createHtmlElement(header,'','div',['header__open-menu__substrate','non-canvas']);
    const rightSide = createHtmlElement(header,'','div',['header__right-side__container']);
    const closeAsideMenuBtn = createHtmlElement(leftSide,'','div',['header__aside-menu__close-btn','icon-close']);
    const projectTitleName = crmSettings.general.projectName.charAt(0).toUpperCase() + crmSettings.general.projectName.slice(1);
    const projectTitle = createHtmlElement(header, projectTitleName,'h1',['header__title']);
    const logo = createHtmlElement(leftSide,'','div',['header__logo']);
    const logoImg = createHtmlElement(logo,'','img',['header__logo-img']);
    logoImg.src = crmSettings.general.logo;
    const nav = createHtmlElement(leftSide,'','nav',['header__navigation']);
    const navMenu = createHtmlElement(nav,'','ul',['header__navigation-menu']);

    Object.entries(crmSettings.general.menuItems).forEach(([key,value]) =>{
        if (value){
            const webName = changeLangToCurrent(key);
            const menuItem = createHtmlElement(navMenu,'','li',['header__navigation-menu__item']);
            const span = createHtmlElement(menuItem,'','span',['header__navigation-menu__href__wrapper']);
            const menuHref = createHtmlElement(span,webName,'a',['header__navigation-menu__href']);
            menuHref.dataset.menuItem = key;

            // if (key === 'about' || key === 'gallery'){
            //     setTimeout(()=>{
            //         openPage(key,crmSettings.general,true);
            //     },400)
            // }

            if (key === '3dModel'){
                span.classList.add('active-menu');
            }
        }
    });

    addMobileHeaderElements(leftSide);

    const langToggle = createHtmlElement(rightSide,'','div',['header__lang-toggle','icon-site']);
    //Log in
    const loginContainer = createHtmlElement(rightSide,'','div',['header__login-container']);
    const btnLogin = createHtmlElement(loginContainer,'Log in','button',['header__login-btn','hide-header-section']);
    const btnSignUp = createHtmlElement(loginContainer,'Sign up','button',['header__sign-up__btn','hide-header-section']);

    //Favorites
    const favContainer = createHtmlElement(rightSide,'','div',['header__favorites-container','hide-header-section']);
    const userIcon = createHtmlElement(favContainer,'','div',['header__user-profile','icon-user']);
    const favCounterContainer = createHtmlElement(favContainer,'','div',['header__favorites-counter','icon-favorite_selected']);
    const favCount = createHtmlElement(favCounterContainer,'0','span',['header__fav-count']);
    // const apply = createHtmlElement(rightSide,'Apply now','button',['header__apply-now','icon-call']);


    navMenu.addEventListener('click', (e)=> menuHandler(e,crmSettings.general));
    logo.addEventListener('click',()=> goHome(crmSettings.general));
    closeAsideMenuBtn.addEventListener('click', () => closeAsideMenu());
    burgerMenu.addEventListener('click',()=>addScrollInfoBlock(nav));
    nav.onscroll = ()=> hideInfoDots();

    substrateMenu.addEventListener('mousedown',()=>closeAsideMenu());
    substrateMenu.addEventListener('touchstart',()=>closeAsideMenu());
    header.style.visibility = 'hidden';
    setTimeout(()=>headerState(true),300);
}

function loadMenuPage (crm) {



}

function hideInfoDots () {
    const dots = document.querySelector('.header__navigation-menu__dots');
    if (dots){
        dots.style.display = 'none';
    }
}

function addScrollInfoBlock (nav) {
    const navVisibleHeight = nav.offsetHeight;
    const navHeight = nav.scrollHeight;
    if (navVisibleHeight !== navHeight){
        const isExist = document.querySelector('.header__navigation-menu__dots');
        if (isExist){
            return;
        }
        const menu = document.querySelector('.header__navigation-menu');
        const totalMenuItems = menu.children.length;
        const menuItemHeight = menu.firstElementChild.getBoundingClientRect().height;
        const elementMargin = parseInt(getComputedStyle(menu.firstElementChild)['marginBottom']);

        let visibleElementsHeight = 0;

        for (let i=0; i< totalMenuItems; i++){
            visibleElementsHeight += menuItemHeight + elementMargin;

            if (visibleElementsHeight >= navVisibleHeight){
                const diffHeight = visibleElementsHeight - navVisibleHeight;
                const dots = createHtmlElement('','and more','li',['header__navigation-menu__item','header__navigation-menu__dots','icon-more']);

                if (diffHeight > menuItemHeight){
                    dots.style.marginTop = menuItemHeight - diffHeight + 'px';
                }

                dots.addEventListener('click',()=> scrollMenu(nav));
                menu.children[i].insertAdjacentElement('beforebegin',dots);
                return;
            }
        }
    }
}

function scrollMenu (nav) {
    const totalScroll = nav.scrollHeight - nav.offsetHeight;
    nav.scroll(0,totalScroll);
}

export function headerState (loop = false) {
    if (loop){
        const lang = getCurrentLangDirection();
        const header = document.querySelector('header');
        if (!header){
            return;
        }
        const headerWidth = header.offsetWidth;
        const scrollWidth = header.scrollWidth;

        const menuItems = document.querySelectorAll('.header__navigation-menu__item');

        let marginDirection;

        switch (lang) {
            case 'ltr':
                marginDirection = 'marginLeft';
                menuItems.forEach(item =>{
                    item.style.removeProperty('margin-right');
                });

            break;
            case 'rtl':
                marginDirection = 'marginRight';
                menuItems.forEach(item =>{
                    item.style.removeProperty('margin-left');
                });

            break;
        }

        let menuMargin = parseInt(getComputedStyle(menuItems[0])[marginDirection]);
        const minMargin = 16;
        const maxMargin = 40;

        if (isMobile){
            header.classList.add('mobile__style');
            header.style.removeProperty('visibility');
            return;
        }

        if (headerWidth < scrollWidth){
            if (menuMargin > minMargin){
                menuMargin--;
                menuItems.forEach(item =>{
                    item.style[marginDirection] = menuMargin + 'px';
                });
                headerState(true);
                settingsData.headerObjectState.lastSize = window.innerWidth;
            } else {
                headerState(false);
                header.style.removeProperty('visibility');
                header.classList.add('mobile__style');
                settingsData.headerObjectState.lastSizeWhenMobileMenuActivated = scrollWidth;
            }
        } else{
            header.style.removeProperty('visibility');
        }
    }
}

export function resizeHeader () {
    const lang = getCurrentLangDirection();
    let marginDirection;
    let removeMarginDirection;

    switch (lang) {
        case 'ltr':
            marginDirection = 'marginLeft';
            removeMarginDirection = 'margin-left';
            break;
        case 'rtl':
            marginDirection = 'marginRight';
            removeMarginDirection = 'margin-right';
            break;
    }

    const header = document.querySelector('header');
    if (!header){
        return;
    }
    const headerWidth = header.offsetWidth;
    const scrollWidth = header.scrollWidth;
    const menuItems = document.querySelectorAll('.header__navigation-menu__item');
    let menuMargin = parseInt(getComputedStyle(menuItems[0])[marginDirection]);
    const minMargin = 16;
    const maxMargin = 40;

    resizeIframeWithHeaderHeight();

    if (isMobile){
        header.classList.add('mobile__style');
        return;
    }

    if (settingsData.headerObjectState.lastSize > window.innerWidth){
        if (headerWidth < scrollWidth){
            if (menuMargin > minMargin){
                menuMargin--;
                menuItems.forEach(item =>{
                    item.style[marginDirection] = menuMargin + 'px';
                });
            } else {
                header.classList.add('mobile__style');
                settingsData.headerObjectState.lastSizeWhenMobileMenuActivated = scrollWidth;
                menuItems.forEach(item =>{
                    item.style.removeProperty(removeMarginDirection);
                });
            }
        }
    }

    if (settingsData.headerObjectState.lastSize < window.innerWidth){
        if (menuMargin < maxMargin){
            if (headerWidth === scrollWidth){
                menuMargin++;
                menuItems.forEach(item =>{
                    item.style[marginDirection] = menuMargin + 'px';
                });
            }
        }

        if (header.classList.contains('mobile__style')){
            if (settingsData.headerObjectState.lastSizeWhenMobileMenuActivated < window.innerWidth){
                header.classList.remove('mobile__style');
            }
        }
    }

    settingsData.headerObjectState.lastSize = window.innerWidth;
}

function addMobileHeaderElements (leftSide) {
    const menu = leftSide.querySelector('.header__navigation-menu');
    // const favItem = createHtmlElement(menu,'','li',['header__navigation-menu__item','hide-header-section']);
    // const span = createHtmlElement(favItem,'','span',['header__navigation-menu__href__wrapper']);
    // const favHref = createHtmlElement(span,'Favorites','a',['header__navigation-menu__href']);
    // favHref.dataset.menuItem = 'favorites';

    const rightSide = createHtmlElement(leftSide,'','div',['header__right-side__container__mobile','hide-header-section']);
    // const apply = createHtmlElement(rightSide,'Apply now','button',['header__apply-now','icon-call']);
    const btnSignUp = createHtmlElement(rightSide,'Sign up','button',['header__sign-up__btn','hide-header-section']);
    const loginContainer = createHtmlElement(rightSide,'','div',['header__login-container']);
    const btnLogin = createHtmlElement(loginContainer,'Log in','button',['header__login-btn','hide-header-section']);

    if (config.languages.length > 1) {
        const langToggle = createHtmlElement(loginContainer, '', 'div', ['header__lang-toggle', 'icon-site']);
    }

    setIcoMoon();
}

function setIcoMoon () {
    const icons ={
        '3D model': 'icon-cylinder-building',
        'About': 'icon-info',
        'Apply now': 'icon-external-link',
        'Availability': 'icon-available2',
        'Gallery': 'icon-gallery',
        'Get app': ['icon-playmarket','icon-appstore'],
        'Map': 'icon-map-pin-outline',
        'Favorites': 'icon-unselected',
        'Contact us': 'icon-call',
    };

    const menuItems = document.querySelectorAll('.header__navigation-menu__href');
    menuItems.forEach(menu =>{
       const icon = icons[menu.textContent];
       if (icon){
           if (Array.isArray(icon)){
               menu.classList.add(icon[0]);
               menu.parentElement.classList.add(icon[1]);
           } else {
               menu.classList.add(icon);
           }
       }
    });
}

function goHome (crm) {
    const menuItems = document.querySelectorAll('.header__navigation-menu__href');
    menuItems.forEach(item =>{
        if (item.dataset.menuItem.startsWith('3')){
            menuHandler(item,crm);
        }
    });
}

export function menuHandler (e, crm) {
    rightNavMenuZIndexChange(1);
    if (e instanceof HTMLElement){
        const activeMenu = document.querySelector('.header__navigation-menu__href__wrapper.active-menu');
        activeMenu.classList.remove('active-menu');
        e.parentElement.classList.add('active-menu');
        closePages();
        openPage(e.dataset.menuItem,crm);
        closeAsideMenu();
    } else {
        if (e.target.classList.contains('header__navigation-menu__href')){
            const activeMenu = document.querySelector('.header__navigation-menu__href__wrapper.active-menu');
            activeMenu.classList.remove('active-menu');
            e.target.parentElement.classList.add('active-menu');
            closePages();
            openPage(e.target.dataset.menuItem,crm);
            closeAsideMenu();
        }
    }
}

function closeAsideMenu () {
    const asideMenuToggle = document.querySelector('.header__burger-menu__input');
    if (asideMenuToggle.checked){
        asideMenuToggle.checked = false;
    }

    rightNavMenuZIndexChange();
}

// export function closePages (crm) {
//     const activePage = document.querySelector('.widget__container.show-page');
//     activePage && activePage.classList.remove('show-page');
//     // Object.keys(crm.menuItems).forEach(menuItem =>{
//     //    const pageExist = isPageExist(menuItem);
//     //    if (pageExist && pageExist.classList.contains('show-page')){
//     //        pageExist.classList.remove('show-page');
//     //    }
//     // });
// }

export function isPageExist (dataSet) {
    return document.querySelector(`.widget__container[data-menu-item="${dataSet}"`);
}

function resizeIframeWithHeaderHeight () {
    const header = document.querySelector('header');
    const allIframe = document.querySelectorAll('.content__page');
    if (allIframe.length){
       allIframe.forEach(iframe => {
           iframe.style.paddingTop = header.getBoundingClientRect().height + 'px';
       })
    }
}

export function openPage (data,crm,autoLoad = false) {
    let headerHeight = 0;
    const header = document.querySelector('header');
    if (header){
        headerHeight = header.getBoundingClientRect().height;
    }
    const pageExist = isPageExist(data);
    if (!pageExist){
        if (data === '3dModel'){
            return;
        }

        if (!autoLoad){
            const preloaderContainer = createHtmlElement(document.body,'','div',['menu__iframe__preloader']);
            preloaderContainer.style.marginTop = headerHeight + 'px';
            addIframePreloader(preloaderContainer);
        }

        const container = createHtmlElement(document.body,'','iframe',['content__page']);
        if (autoLoad){
            container.classList.add('hide-page');
        }

        container.style.paddingTop = headerHeight + 'px';
        container.dataset.menuItem = data;
        const currentLang = getCurrentLang();
        const url = crm[data + 'WebviewURL']+`&lang=${currentLang}`;
        container.src = url;
        container.onload = ()=> {
            const preloader = document.querySelector('.menu__iframe__preloader');
            if (preloader){
                preloader.remove();
            }
        }
    } else {
        pageExist.classList.remove('hide-page');
    }
}

export function changeHeaderMode () {
        const header = document.querySelector('header');
        if (header && settingsData.activeViewMode === ViewMode.Orbit){
            const angle = getOrbitControlsCurrentPolarAngle();

            if (angle < 1){
                header.classList.add('header-substrate');
            } else {
                header.classList.remove('header-substrate');
            }
        }
}

export function addIframePreloader (container) {
    const preloader = createHtmlElement(container,'','div',['lds-ring']);
    for (let i=0; i < 4; i++){
        const child = createHtmlElement(preloader,'','div',[]);
    }

}

export function removeHeaderSubstrateInCylinder () {
    const header = document.querySelector('header');
    if (header && header.classList.contains('header-substrate')){
        header.classList.remove('header-substrate');
    }
}
